(function () {
  'use strict';

  function initItemSelectionGrids(section) {
    if (!section) return;

    const grids = section.querySelectorAll('[data-grid-id]');

    grids.forEach(function (grid) {
      const gridId = grid.getAttribute('data-grid-id');
      if (!gridId) return;

      const controlsId = gridId.replace('grid-', 'controls-');
      const productSectionWrapper = grid.closest('.product-section-wrapper');
      const controls = productSectionWrapper
        ? productSectionWrapper.querySelector('[data-controls-id="' + controlsId + '"]')
        : section.querySelector('[data-controls-id="' + controlsId + '"]');

      if (!controls) return;

      const prevBtn = controls.querySelector('.sliderControlVertical__prev');
      const nextBtn = controls.querySelector('.sliderControlVertical__next');

      if (!prevBtn || !nextBtn) return;
      if (prevBtn.dataset.hasListener || nextBtn.dataset.hasListener) return;

      prevBtn.dataset.hasListener = 'true';
      nextBtn.dataset.hasListener = 'true';

      let currentPage = 1;
      let previousPage = 1;
      let totalPages = 1;
      let isAnimating = false;
      let isResizing = false;

      function getProductsPerPage() {
        return 6;
      }

      function createPagination() {
        const pagination = controls.querySelector('.sliderControlVertical__pagination');
        if (!pagination) return;

        const totalProductsAttr = pagination.getAttribute('data-total-products');
        const totalProducts = totalProductsAttr ? parseInt(totalProductsAttr, 10) : 0;
        const productsPerPage = getProductsPerPage();

        totalPages = Math.ceil(totalProducts / productsPerPage);

        if (currentPage > totalPages && totalPages > 0) {
          currentPage = totalPages;
        }

        if (totalPages <= 1 || totalProducts === 0) {
          controls.style.display = 'none';
          controls.style.visibility = 'hidden';
          grid.querySelectorAll('.item-selection-product-card').forEach(function (product) {
            if (product) product.style.display = '';
          });
          currentPage = 1;
          previousPage = 1;
          return;
        }

        controls.style.display = 'flex';
        controls.style.visibility = 'visible';
        controls.style.opacity = '1';
        pagination.innerHTML = '';

        for (let i = 1; i <= totalPages; i++) {
          const bullet = document.createElement('span');
          bullet.className = 'sliderControlVertical__pagination-bullet';
          if (i === currentPage) {
            bullet.classList.add('sliderControlVertical__pagination-bullet--active');
          }
          bullet.setAttribute('tabindex', '0');
          bullet.setAttribute('role', 'button');
          bullet.setAttribute('aria-label', 'Go to slide ' + i);
          bullet.setAttribute('data-page', String(i));
          bullet.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            const pageNum = parseInt(this.getAttribute('data-page'), 10);
            if (!isNaN(pageNum) && pageNum >= 1 && pageNum <= totalPages) {
              goToPage(pageNum);
            }
          });
          pagination.appendChild(bullet);
        }

        updateBullets();
        updateButtons();
      }

      function updateBullets() {
        controls.querySelectorAll('.sliderControlVertical__pagination-bullet').forEach(function (bullet, index) {
          if (index + 1 === currentPage) {
            bullet.classList.add('sliderControlVertical__pagination-bullet--active');
          } else {
            bullet.classList.remove('sliderControlVertical__pagination-bullet--active');
          }
        });
      }

      function syncBannerHeight() {
        const staticItem = grid.closest('.item-selection-static-item');
        if (!staticItem) return;

        const bannerContent = staticItem.querySelector('.banner-content');
        const productsGrid = staticItem.querySelector('.item-selection-products-grid');

        if (bannerContent && productsGrid && window.innerWidth >= 1024) {
          requestAnimationFrame(function () {
            const gridHeight = productsGrid.offsetHeight;
            if (gridHeight > 0) {
              bannerContent.style.height = gridHeight + 'px';
              bannerContent.style.minHeight = gridHeight + 'px';
            }
          });
        } else if (bannerContent && window.innerWidth < 1024) {
          bannerContent.style.height = '';
          bannerContent.style.minHeight = '';
        }
      }

      function updateGrid(animate) {
        if (animate === undefined) animate = true;

        const productsPerPage = getProductsPerPage();
        const products = grid.querySelectorAll('.item-selection-product-card');
        const startIndex = (currentPage - 1) * productsPerPage;
        const endIndex = startIndex + productsPerPage;
        const newProducts = [];
        const oldProducts = [];

        products.forEach(function (product, index) {
          if (!product) return;
          if (index >= startIndex && index < endIndex) {
            newProducts.push(product);
          } else if (!product.classList.contains('hidden') && !product.hasAttribute('hidden')) {
            oldProducts.push(product);
          }
        });

        if (!animate || isResizing) {
          products.forEach(function (product, index) {
            if (!product) return;
            product.classList.remove('product-card--exiting', 'product-card--entering', 'product-card--active', 'hidden');
            product.style.transition = 'none';
            product.style.transitionDelay = '';
            product.style.transform = '';

            if (index >= startIndex && index < endIndex) {
              product.style.display = '';
              product.removeAttribute('hidden');
            } else {
              product.classList.add('hidden');
              product.setAttribute('hidden', '');
            }
          });

          updateBullets();
          updateButtons();
          syncBannerHeight();
          return;
        }

        isAnimating = true;
        const offset = 40;

        oldProducts.forEach(function (product) {
          product.classList.add('product-card--exiting');
          product.style.transform = 'translateX(' + -offset + 'px)';
        });

        requestAnimationFrame(function () {
          oldProducts.forEach(function (product) {
            product.classList.add('hidden');
            product.setAttribute('hidden', '');
          });

          newProducts.forEach(function (product, idx) {
            product.style.display = '';
            product.removeAttribute('hidden');
            product.classList.remove('product-card--exiting', 'product-card--active', 'hidden');
            product.classList.add('product-card--entering');
            product.style.transition = 'none';
            product.style.transitionDelay = '';
            product.style.transform = 'translateX(' + offset + 'px)';

            requestAnimationFrame(function () {
              requestAnimationFrame(function () {
                product.style.transition = '';
                product.style.transitionDelay = idx * 100 + 'ms';
                product.classList.add('product-card--active');
                product.classList.remove('product-card--entering');
              });
            });
          });

          updateBullets();
          updateButtons();
          syncBannerHeight();

          setTimeout(function () {
            isAnimating = false;
          }, 800);
        });
      }

      function updateButtons() {
        if (currentPage === 1) {
          prevBtn.classList.add('swiper-button-disabled');
          prevBtn.setAttribute('aria-disabled', 'true');
          prevBtn.disabled = true;
        } else {
          prevBtn.classList.remove('swiper-button-disabled');
          prevBtn.setAttribute('aria-disabled', 'false');
          prevBtn.disabled = false;
        }

        if (currentPage === totalPages) {
          nextBtn.classList.add('swiper-button-disabled');
          nextBtn.setAttribute('aria-disabled', 'true');
          nextBtn.disabled = true;
        } else {
          nextBtn.classList.remove('swiper-button-disabled');
          nextBtn.setAttribute('aria-disabled', 'false');
          nextBtn.disabled = false;
        }
      }

      function goToPage(page) {
        if (typeof page !== 'number' || page < 1 || totalPages <= 0) return;
        if (page > totalPages) page = totalPages;
        if (page === currentPage || isAnimating) return;

        isAnimating = true;

        if (grid._animationTimeout) {
          clearTimeout(grid._animationTimeout);
          grid._animationTimeout = null;
        }
        if (grid._staggerTimeouts) {
          grid._staggerTimeouts.forEach(function (id) {
            clearTimeout(id);
          });
          grid._staggerTimeouts = [];
        }

        previousPage = currentPage;
        currentPage = page;
        updateGrid(true);

        if (grid._heightSyncTimeout) clearTimeout(grid._heightSyncTimeout);
        grid._heightSyncTimeout = setTimeout(syncBannerHeight, 500);
      }

      prevBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        if (isAnimating) return;
        if (currentPage > 1 && totalPages > 0) goToPage(currentPage - 1);
      });

      nextBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        if (isAnimating) return;
        if (currentPage < totalPages && totalPages > 0) goToPage(currentPage + 1);
      });

      createPagination();
      updateGrid(false);
      setTimeout(function () {
        syncBannerHeight();
        setTimeout(syncBannerHeight, 300);
      }, 200);

      let gridSwipeStart = null;
      let isSwiping = false;
      const gridItem = grid.closest('.item-selection-static-item');

      grid.addEventListener(
        'touchstart',
        function (e) {
          if (e.target && e.target.closest && e.target.closest('.quick-add-button-wrapper')) return;
          if (window.innerWidth < 1024) {
            gridSwipeStart = {
              x: e.touches[0].clientX,
              y: e.touches[0].clientY,
              time: Date.now()
            };
            isSwiping = false;
          }
        },
        { passive: true }
      );

      grid.addEventListener(
        'touchmove',
        function (e) {
          if (!gridSwipeStart || window.innerWidth >= 1024) return;

          const touch = e.touches[0];
          const diffX = gridSwipeStart.x - touch.clientX;
          const diffY = Math.abs(gridSwipeStart.y - touch.clientY);

          if (Math.abs(diffX) > 10 && Math.abs(diffX) > diffY * 1.5) {
            if (!isSwiping) {
              isSwiping = true;
              if (gridItem) gridItem.classList.add('swiping');
            }
            e.preventDefault();
          } else if (isSwiping && Math.abs(diffY) > Math.abs(diffX) * 1.5) {
            isSwiping = false;
            if (gridItem) gridItem.classList.remove('swiping');
          }
        },
        { passive: false }
      );

      grid.addEventListener(
        'touchend',
        function (e) {
          if (gridItem) gridItem.classList.remove('swiping');

          if (
            !gridSwipeStart ||
            (e.target && e.target.closest && e.target.closest('.quick-add-button-wrapper')) ||
            window.innerWidth >= 1024
          ) {
            gridSwipeStart = null;
            isSwiping = false;
            return;
          }

          const swipeEnd = {
            x: e.changedTouches[0].clientX,
            y: e.changedTouches[0].clientY,
            time: Date.now()
          };
          const diffX = gridSwipeStart.x - swipeEnd.x;
          const diffY = Math.abs(gridSwipeStart.y - swipeEnd.y);
          const diffTime = swipeEnd.time - gridSwipeStart.time;

          if (
            (isSwiping || Math.abs(diffX) > 30) &&
            Math.abs(diffX) > 30 &&
            diffY < 200 &&
            diffTime < 500
          ) {
            e.preventDefault();
            e.stopPropagation();
            if (diffX > 0) {
              if (currentPage < totalPages && totalPages > 0) goToPage(currentPage + 1);
            } else if (diffX < 0) {
              if (currentPage > 1 && totalPages > 0) goToPage(currentPage - 1);
            }
          }

          gridSwipeStart = null;
          isSwiping = false;
        },
        { passive: false }
      );

      grid.addEventListener(
        'touchcancel',
        function () {
          if (gridItem) gridItem.classList.remove('swiping');
          gridSwipeStart = null;
          isSwiping = false;
        },
        { passive: true }
      );

      let resizeTimeoutPagination;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimeoutPagination);
        if (grid._animationTimeout) {
          clearTimeout(grid._animationTimeout);
          grid._animationTimeout = null;
        }
        isAnimating = false;
        isResizing = true;
        resizeTimeoutPagination = setTimeout(function () {
          const oldTotalPages = totalPages;
          const oldCurrentPage = currentPage;
          createPagination();
          if (currentPage > totalPages && totalPages > 0) currentPage = totalPages;
          if (oldTotalPages !== totalPages || oldCurrentPage !== currentPage) {
            previousPage = oldCurrentPage;
            updateGrid(false);
          } else {
            const productsPerPage = getProductsPerPage();
            grid.querySelectorAll('.item-selection-product-card').forEach(function (product, index) {
              if (!product) return;
              const pageNumber = Math.floor(index / productsPerPage) + 1;
              if (pageNumber === currentPage) {
                product.style.display = '';
                product.removeAttribute('hidden');
                product.classList.remove('hidden');
                product.style.opacity = '1';
                product.style.transform = '';
              } else {
                product.classList.add('hidden');
                product.setAttribute('hidden', '');
              }
            });
          }
          isResizing = false;
          setTimeout(syncBannerHeight, 200);
        }, 250);
      });
    });
  }

  function bootStaticSections() {
    document.querySelectorAll('.item-selection-static-section').forEach(initItemSelectionGrids);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootStaticSections);
  } else {
    bootStaticSections();
  }

  document.addEventListener('shopify:section:load', function (event) {
    const target = event.target;
    if (!target) return;
    if (target.classList && target.classList.contains('item-selection-static-section')) {
      initItemSelectionGrids(target);
      return;
    }
    const nested = target.querySelector('.item-selection-static-section');
    if (nested) initItemSelectionGrids(nested);
  });
})();
